import React, { ReactElement, useState } from 'react'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import Truncate from 'react-truncate'
import { Link } from '@contrast-security-inc/design-system-typography'

const paragraphCss = css`
  margin: 0;
`

export const linkCss = css`
  font-size: 12px;
  display: block;
`

export interface ParagraphProps {
  readonly values: string[]
  readonly lines: number
  readonly showAllTextId: string
}

export function TruncatedListParagraph({
  values,
  lines,
  showAllTextId
}: ParagraphProps) {
  const [isExpanded, setExpanded] = useState(false)
  const [isTruncated, setTruncated] = useState(false)

  return (
    <div>
      {
        <React.Fragment>
          <Truncate
            lines={!isExpanded && lines}
            ellipsis={'...'}
            onTruncate={(val) => {
              setTruncated(val)
            }}
          >
            {renderText(values)}
          </Truncate>
          {showAllText(
            showAllTextId,
            isExpanded,
            isTruncated,
            setExpanded,
            values.length
          )}
          {showLessText(isExpanded, setExpanded)}
        </React.Fragment>
      }
    </div>
  )
}

function renderText(values) {
  return <p className={paragraphCss}>{values.join(', ')}</p>
}

export function showAllText(
  showAllTextId: string,
  expanded: boolean,
  truncated: boolean,
  setExpanded: (boolean) => void,
  count: number
): ReactElement | undefined {
  if (!expanded && truncated) {
    return (
      <FormattedMessage id={showAllTextId}>
        {(text) => (
          <Link className={linkCss} onClick={() => setExpanded(true)}>
            {`${text} (${count})`}
          </Link>
        )}
      </FormattedMessage>
    )
  }
}

export function showLessText(
  expanded: boolean,
  setExpanded: (boolean) => void
): ReactElement | undefined {
  if (expanded) {
    return (
      <FormattedMessage id={'action_showLess'}>
        {(text) => (
          <Link className={linkCss} onClick={() => setExpanded(false)}>
            {text}
          </Link>
        )}
      </FormattedMessage>
    )
  }
}
